/**
 * Who liked a comment, as its tooltip and description say (GH #2796; spec L2, L3). One or three are all named; from
 * four, the first two and how many others (L3).
 */
export const likersText = (names: string[]) => {
  const [first, second, third] = names
  if (!first) {
    return ''
  }
  if (!second) {
    return `Liked by ${first}`
  }
  if (names.length === 2) {
    return `Liked by ${first} and ${second}`
  }
  if (names.length === 3 && third) {
    return `Liked by ${first}, ${second} and ${third}`
  }
  return `Liked by ${first}, ${second} and ${names.length - 2} others`
}

/** The Like button's name (L1), with the likes it has (L4) */
export const likeButtonName = (author: string, isTask: boolean, count: number) => {
  const name = `Like ${author}'s ${isTask ? 'task' : 'comment'}`
  return count === 0 ? name : `${name}, ${count} ${count === 1 ? 'like' : 'likes'}`
}
